// import React, { useState } from "react";
// import { styled } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import Paper from "@mui/material/Paper";
// import Grid from "@mui/material/Grid";
// import LogoImage from "../../assets/img/logo.svg"
// import {
//   Container,
//   FormControl,
//   TextField,
//   Button,
//   Typography,
//   Checkbox,

//   fontWeight,
//   Card
// } from "@mui/material";
// import { setSession } from "../../utils/commonUtils";
// import { registerApi } from "./registrationApi";
// import { useNavigate } from "react-router";
// import { routePath } from "../../constants/routePath";

// import { Link } from "react-router-dom";
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
// }));

// const UserRegistration = () => {
//   const navigate=useNavigate()
//   const [formData, setFormData] = useState({
//     name: "",
//     language: "en",
//     mobileNumber: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log(formData);
//     registerApi(formData,(data)=>{
//       console.log("Data",data)
//       setSession("eleGentUser",data)
//       navigate(routePath.OTP)
//     })
//   };

//   const label = { inputProps: { "aria-label": "Checkbox demo" } };

//   return (
//     <Container sx={{ marginTop: "20px" }}>
//       <Card sx={{ flexGrow: 1 , padding:4}}>
//         <form onSubmit={handleSubmit}>
//           <Grid container spacing={2} columns={12}>
//             <Grid item xs={6}>

//                 <img
//                   src={LogoImage}
//                   alt="Contact us"
//                   style={{ width: "100%" }}
//                 />

//             </Grid>
//             <Grid item xs={6}>
//               <Grid item xs={12}>
//                 <FormControl fullWidth margin="normal">
//                   <TextField
//                     label="Mobile Number"
//                     name="mobileNumber"
//                     type="number"
//                     value={formData.mobileNumber}
//                     onChange={handleChange}
//                     required
//                     InputLabelProps={{ className: "mulish" }}
//                     InputProps={{ classes: { input: "mulish" } }}
//                   />
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControl fullWidth margin="normal">
//                   <TextField
//                     label="User Name"
//                     name="name"
//                     type="text"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                     InputLabelProps={{ className: "mulish" }}
//                     InputProps={{ classes: { input: "mulish" } }}
//                   />
//                 </FormControl>
//               </Grid>
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <Checkbox {...label} />
//                 <Typography>I have read and accept the</Typography>
//               </Box>
//               <Box sx={{ display: "flex", alignItems: "center", pl: 1 }}>
//                 <Link to={routePath.TERMSOFSERVICE} style={{ textDecoration: "none", color: "#00b0dc",cursor:'pointer', fontWeight:"500" }}>
//                   Terms of Service
//                 </Link>
//                 <Typography px={1}>and</Typography>
//                 <Link to={routePath.PRIVACYPOLICY} style={{ textDecoration: "none", color: "#00b0dc",cursor:'pointer', fontWeight:"500" }}>
//                   Privacy Policy
//                 </Link>
//               </Box>
//               <Box sx={{ mt: 2}}>
//                 <Button
//                   type="submit"
//                   variant="contained"
//                   color="primary"
//                   sx={{ backgroundColor: "#e80089ed" }}
//                 >
//                   Submitssssssssssss
//                 </Button>
//               </Box>

//               <Box >
//                 <Typography>
//                   Already Registered?

//                   <Link
//                 to={routePath.LOGIN}
//                   style={{
//                     textDecoration:"none",
//                     color: "#2096A4",
//                     cursor: "pointer",
//                     fontWeight: "600",
//                   }}
//                 >
//                  click here to Login!
//                 </Link>
//                 </Typography>
//               </Box>
//             </Grid>
//           </Grid>
//         </form>
//       </Card>
//     </Container>
//   );
// };

// export default UserRegistration;

import React, { useState } from "react";
import {
  Container,
  FormControl,
  TextField,
  Button,
  Typography,
  Checkbox,
  Card,
  Grid,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import LogoImage from "../../assets/img/logo.svg";
import { setSession } from "../../utils/commonUtils";
import { registerApi } from "./registrationApi";
import { routePath } from "../../constants/routePath";
import ElegantLogo from "../../assets/elegantPrimeLogo.png";

const UserRegistration = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    language: "en",
    mobileNumber: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    registerApi(formData, (data) => {
      setSession("eleGentUser", data);
      navigate(routePath.OTP);
    });
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Card
        sx={{
          p: 3,
          background:
            "linear-gradient(90deg, #EBEAFF 0%, #C3C3F8 36.54%, #7E7EEB 59.13%, #01008B 100%)",
          borderRadius: "14px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          minHeight: "70vh",
        }}
      >
        <Grid container spacing={2} alignItems="center">
          {/* Logo */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <img
              src={ElegantLogo}
              alt="Elegant Logo"
              style={{ width: "350px" }}
            />
          </Grid>

          {/* Form */}
          <Grid
            item
            xs={12}
            md={5}
            mt={3}
            sx={{
              backgroundColor: "#fff",
              borderTopLeftRadius: { md: 0, xs: "20px" },
              borderBottomLeftRadius: { md: 0, xs: "20px" },
              borderRadius: { md: "20px", xs: "20px" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: 4,
              py: 6,
            }}
          >
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                width: "100%",
                maxWidth: "320px",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  color: "#01008B",
                  mb: 3,
                  textAlign: "center",
                }}
              >
                SIGN UP
              </Typography>

              <FormControl fullWidth margin="normal">
                <TextField
                  label="Mobile Number"
                  name="mobileNumber"
                  type="tel"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  required
                  size="small"
                  inputProps={{ maxLength: 10, inputMode: "numeric" }}
                />
              </FormControl>

              <FormControl fullWidth margin="normal">
                <TextField
                  label="User Name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  size="small"
                />
              </FormControl>

              <Box sx={{ display: "flex", alignItems: "flex-start", mt: 1 }}>
                <Checkbox required sx={{ pt: 0 }} />
                <Typography sx={{ fontSize: "13px", mt: "4px" }}>
                  I have read and accept the{" "}
                  <Link
                    to={routePath.TERMSOFSERVICE}
                    style={{
                      textDecoration: "none",
                      color: "#007bff",
                      fontWeight: "500",
                    }}
                  >
                    Terms of Service
                  </Link>{" "}
                  and{" "}
                  <Link
                    to={routePath.PRIVACYPOLICY}
                    style={{
                      textDecoration: "none",
                      color: "#007bff",
                      fontWeight: "500",
                    }}
                  >
                    Privacy Policy
                  </Link>
                </Typography>
              </Box>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  mt: 3,
                  backgroundColor: "#01008B",
                  fontWeight: "600",
                  textTransform: "none",
                  py: 1,
                  borderRadius: "8px",
                }}
              >
                Continue
              </Button>

              <Typography sx={{ mt: 2, textAlign: "center", fontSize: "14px" }}>
                Already Registered?{" "}
                <Link
                  to={routePath.LOGIN}
                  style={{
                    textDecoration: "none",
                    color: "#01008B",
                    fontWeight: "600",
                  }}
                >
                  click here to Login!
                </Link>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default UserRegistration;

// import {
//   Box,
//   Button,
//   FormControlLabel,
//   Paper,
//   Radio,
//   RadioGroup,
//   Typography,
// } from "@mui/material";
// import React, { useState } from "react";
// import ElegantLogo from "../../assets/elegantPrimeLogo.png"; // Adjust the path as needed

// const LanguageSelector = () => {
//   const [language, setLanguage] = useState("english");

//   const handleChange = (event) => {
//     setLanguage(event.target.value);
//   };

//   return (
//     <Box
//       sx={{
//         height: "70vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         backgroundColor: "#ffffff",
//         padding: 2,
//         boxSizing: "border-box",
//         mt:4
//       }}
//     >
//       <Box
//         sx={{
//           width: "90%",
//           maxWidth: "1100px",
//           // height: "500px",
//           display: "flex",
//           justifyContent: "center", // Center content horizontally
//           alignItems: "center",     // Center content vertically
//           background: "linear-gradient(to right, #f1f3ff, #01008B)",
//           borderRadius: 3,
//           py: 4,
//           px: 2,
//           boxShadow: 5,
//         }}
//       >
//         {/* Logo Section */}
//         <Box
//           sx={{
//             flex: 1,
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           <img
//             src={ElegantLogo}
//             alt="Elegant Prime Logo"
//             style={{ width: 350, maxWidth: "100%" }}
//           />
//         </Box>

//         {/* Language Card */}
//         <Box
//           sx={{
//             flex: 1,
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           <Paper
//             elevation={3}
//             sx={{
//               width: 300,
//               padding: 3,
//               borderRadius: 3,
//               backgroundColor: "#fff",
//             }}
//           >
//             <Typography
//               variant="h6"
//               gutterBottom
//               sx={{ color: "#01008B", fontWeight: "bold" }}
//             >
//               Select Language
//             </Typography>

//             <RadioGroup value={language} onChange={handleChange}>
//               {[
//                 { label: "English", value: "english" },
//                 { label: "हिंदी", value: "hindi" },
//                 { label: "मराठी", value: "marathi" },
//               ].map((item) => (
//                 <Box
//                   key={item.value}
//                   sx={{
//                     borderBottom: "2px solid #7D7D7D",
//                     marginBottom: 1,
//                     paddingBottom: 1,
//                   }}
//                 >
//                   <FormControlLabel
//                     value={item.value}
//                     control={<Radio />}
//                     label={item.label}
//                     sx={{ marginLeft: 0 }}
//                   />
//                 </Box>
//               ))}
//             </RadioGroup>

//             <Button
//               fullWidth
//               variant="contained"
//               sx={{
//                 marginTop: 2,
//                 py: 1,
//                 backgroundColor: "#01008B",
//                 "&:hover": {
//                   backgroundColor: "#02007A",
//                 },
//               }}
//             >
//               Set Language
//             </Button>
//           </Paper>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default LanguageSelector;
